import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'component-tip',
	templateUrl: './component.tip.html',
	styleUrls: ['./component.tip.css']
})
export class ComponentTip implements OnInit {

	@Input() sureText:string = "确定";
	@Input() cancelText:string = "取消";
	@Input() desText:string = "";
	@Input() type: string = "tip";
	@Input() theme: string;
	@Input() returnType: number = 0;
	@Input() tipType: string = "";
	@Output() onSure = new EventEmitter<any>();
	@Output() onCancel = new EventEmitter<any>();
	@Output() onAnother = new EventEmitter<any>();
	constructor() {
	}
 
	ngOnInit() {
	  console.log(this.returnType);
	}
 
	sure(){
	  if(this.returnType === 0){
		 this.onSure.emit();
	  }else{
		 this.onAnother.emit(true);
	  }
	}
 
	cancel(){
	  this.onCancel.emit();
	}

}


// WEBPACK FOOTER //
// ./src/component/tip/component.tip.ts